import { render, staticRenderFns } from "./SaveTemplate.vue?vue&type=template&id=65977874&"
import script from "./SaveTemplate.vue?vue&type=script&lang=ts&"
export * from "./SaveTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./SaveTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports